import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem,
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import DEFINE, { PATHS, UPLOAD_DIRECTORY, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { message } from 'antd';
import { isEqual, get, debounce, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Homestay from '../../../../../models/Homestay.js';
import Wrapper from '../../../common/component/Wrapper';
import Button from '../../../common/component/Button';
import BasicInfo from './BasicInfo';
import AddressInfo from './AddressInfo';
import { getProvinceByName } from '../../../../../models/Province';
import { cloneDeep } from 'lodash'

import './HomestayDetail.less';
import TranslateButton from '../../../common/component/TranslateButton';

let permisionRateActions = [];
let permisionBookablePackageRateActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {}
};

export default class HomestayDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            homestay: this.props.homestayState?.detail?.homestay,
            uploadFiles: [],
            tagGroups: this.props.homestayState?.tagGroups
        };
        this.basicInfoRef = React.createRef()
    }

    componentDidMount() {
        this.initDetail()
        this.props.getListAmenities();
        permisionRateActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        permisionBookablePackageRateActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BOOKABLEPACKAGERATES);
    }

    componentWillUnmount() {
        this.props.setHomestayDetail(new Homestay())
        this.props.setTagGroupDetailSku([])
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.homestayState.detail.homestay && !isEqual(nextProps.homestayState.detail.homestay, this.props.homestayState.detail.homestay)) {
            this.setHomestayDetail(nextProps.homestayState.detail.homestay)
        }
        if (nextProps.uploadState.file && !isEqual(nextProps.uploadState.file, this.props.uploadState.file)) {
            this.processUploadedFiles(nextProps.uploadState.file);
        }
        if (nextProps.homestayState.tagGroups && !isEqual(nextProps.homestayState.tagGroups, this.props.homestayState.tagGroups)) {
            this.setDataGroupTagDetail(nextProps.homestayState.tagGroups);
            const tagsGroupChange = (nextProps.homestayState.tagGroups || []).map(item => {
                return {
                    name: item.name,
                    tagGroupDetailId: item.id,
                    skuId: item.tagGroupDetailSkus?.[0]?.skuId,
                    isActiveListing: item.tagGroupDetailSkus?.[0]?.isActiveListing
                }
            })
            this.setState({ tagGroups: tagsGroupChange })
        }
    }

    render() {
        const { t, uploadState, homestayState, generalState, locationState, amenityState } = this.props;
        const { isFetching } = homestayState;
        const locations = locationState.dataList;
        const { action, isSubmit, isGetItem, validation, homestay, tagGroups } = this.state;
        const { amenities } = amenityState;

        return (
            <LoadingComponent spinning={isFetching || generalState.isFetching || isSubmit}>
                <PageListComponent className="homestay-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'homestays'}
                        titleHeader={action === DETAIL_ACTIONS.CREATE
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.homestay.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.homestay.title')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={homestay.translations}
                                current={homestay.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChangeDetail('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        activeComponent={'SWITCH'}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        titleActiveComponent={homestay.isActive ? t(`item.homestay.active`) : t(`item.homestay.deActive`)}
                        submitButtonRight={true}
                        statusActiveName={`isActive`}
                        statusActive={homestay.isActive}
                        additionalButton={this.renderFooterButtons()}
                    >
                        <Wrapper className='col-md-6 basic-section'>
                            <BasicInfo homestay={homestay}
                                action={action}
                                ref={this.basicInfoRef}
                                uploading={uploadState.isFetchingMultiple}
                                validation={validation}
                                onChange={this.onChangeDetail}
                                onUploadImage={this.onUploadImages}
                                onRemoveImage={this.removeImages}
                                amenities={amenities} />
                        </Wrapper>
                        <Wrapper className='col-md-6 address-section'>
                            <AddressInfo homestay={homestay}
                                action={action}
                                locations={locations}
                                provinces={generalState.provinces}
                                validation={validation}
                                onSelectPlace={this.onSelectPlace}
                                onChange={this.onChangeDetail}
                                tagGroups={tagGroups}
                                onChangeTags={this.onChangeTags} />
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    renderFooterButtons() {
        const { action } = this.state;

        return (
            <Wrapper className="footer-manage-buttons">
                {action !== DETAIL_ACTIONS.TRANSLATE &&
                    <Fragment>
                        <Button className="btn mr-2" icon="bars" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageRoomTypes}>{this.props.t(`navigation.roomTypes`)}</Button>
                        {/* <Button className="btn mr-2" icon="dollar" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageCustomPrices}>{this.props.t(`navigation.customPrices`)}</Button> */}
                        {permisionRateActions && permisionRateActions.allowView && <Button className="btn mr-2" icon="dollar" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageRates}>{this.props.t(`navigation.rates`)}</Button>}
                        {/* { permisionBookablePackageRateActions && permisionBookablePackageRateActions.allowView && <Button className="btn mr-2" icon="container" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageBookablePackageRates}>{this.props.t(`navigation.bookablePackageRates`)}</Button> } */}
                        {/* <Button className="btn mr-2" icon="logout" onClick={this.onClickRateCompare}>{this.props.t(`navigation.rateCompare`)}</Button> */}
                    </Fragment>
                }
            </Wrapper>
        )
    }

    initDetail() {
        const { match, homestayState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            const homestay = find(homestayState.homestays, h => h.id === id);
            if (homestay) this.setHomestayDetail(homestay);
            this.props.getHomestayDetail(id);
            // this.props.getTagGroupDetailSku(id);
        }
        this.props.getProvinces();
        this.props.getListLocations({
            orderByDesc: false,
            pageIndex: 0,
            pageSize: 100,
            isDomestic: true,
        });
    }

    onChangeDetail = (fieldName, value) => {
        const homestay = this.state.homestay;
        homestay[fieldName] = value;
        this.setState({ homestay });
    };

    onChangeTags = (fieldName, value, index) => {
        const tagGroups = this.state.tagGroups;
        if (fieldName === 'isActiveListing') {
            tagGroups[index][fieldName] = value;
        }
        this.setState({ tagGroups });
    }

    setHomestayDetail = (homestayDetail) => {
        const homestay = cloneDeep(homestayDetail);
        if (this.basicInfoRef.current && this.basicInfoRef.current.setDescription && homestayDetail.description) {
            this.basicInfoRef.current.setDescription(homestayDetail.description)
        }
        this.setState({ homestay, action: homestay.id ? DETAIL_ACTIONS.UPDATE : this.state.action });

    }

    setDataGroupTagDetail = (tagsGruop) => {
        const tagsGroupChange = (tagsGruop || []).filter(item => item).map(item => {
            return {
                name: item.name,
                tagGroupDetailId: item.id,
                skuId: item.tagGroupDetailSkus?.[0]?.skuId,
                isActiveListing: item.tagGroupDetailSkus?.[0]?.isActiveListing
            }
        })
        this.setState({ tagGroups: tagsGroupChange })
    }

    onSelectPlace = (placeData) => {
        const { generalState } = this.props;
        const homestay = this.state.homestay;
        homestay.address = placeData.address;
        homestay.setPosition({ lat: placeData.lat, lng: placeData.lng });
        homestay.country = placeData.place.address_components[placeData.place.address_components.length - 1].long_name || homestay.country;
        homestay.province = getProvinceByName(placeData.address, generalState.provinces);
        if (!homestay.province) {
            homestay.province = getProvinceByName(placeData.place.address_components[placeData.place.address_components.length - 2].long_name, generalState.provinces);
        }
        this.setState({ homestay });
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else {
                this.updateHomestayDetail()
            }
        }
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.HOMESTAY.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { homestay } = this.state;
        // const {tagGroups} = this.props.homestayState;
        homestay.setTranslate(language.code);
        homestay.setData();
        // tagGroups.setTranslate(language.code);
        // tagGroups.setData();
        this.setState({ homestay, action: DETAIL_ACTIONS.TRANSLATE });
        this.tagGroupDetailTranslate(language);
    }

    tagGroupDetailTranslate = (language) => {
        // const { tagGroups } = this.props.homestayState;
        // let newGroupTags = tagGroups;
        // if(language && tagGroups){
        //     newGroupTags = (tagGroups || []).map(item => item.setTranslate(language))
        // }
        // this.setDataGroupTagDetail(newGroupTags);
    }

    onExitTranslate = () => {
        const homestay = cloneDeep(this.state.homestay);
        const action = DETAIL_ACTIONS[homestay.id ? 'UPDATE' : 'CREATE'];
        homestay.setTranslate(undefined, true);
        homestay.setData();
        this.tagGroupDetailTranslate(undefined);
        this.setState({ homestay, action });
    }

    onSaveTranslate = () => {
        const { homestay } = this.state;
        const translateFunction = homestay.translate.id ? this.props.updateHomestayTranslate : this.props.createHomestayTranslate;
        translateFunction(homestay, homestay.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { homestay } = this.state;
        homestay.setTranslate(language.code);
        this.props.deleteHomestayTranslate(homestay, { id: homestay.id });
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestay.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestay.code`)),
                star: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestay.star`)),
                locationId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestay.location`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        if (this.state.homestay.installmentFee || this.state.homestay.installmentLimit) {
            validate.required.installmentFee = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentFee`))
            validate.required.installmentLimit = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentLimit`))
        }
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.homestay, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    processUploadedFiles(fileObj) {
        let uploadFiles = this.state.uploadFiles;
        const homestay = this.state.homestay;
        homestay.addMedia(get(fileObj, 'data.fileUrl'), get(fileObj, 'data.fileName'))
        this.setState({ homestay, uploadFiles });
    }

    onUploadImages = (file) => {
        let fileData = file.target.files;
        let uploadFiles = this.state.uploadFiles;
        if (fileData.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if ((uploadFiles.length + fileData.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(fileData).map((i) => {
            if (imageValidation.includes(fileData[i].type)) {
                this.props.onUploadFile({ file: fileData[i], directory: UPLOAD_DIRECTORY.HOTEL, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    }

    onClickManageRoomTypes = () => {
        const { homestay } = this.state;
        const path = Func.getPathWithParams(PATHS.HOMESTAY_ROOM_TYPE.LIST.path, { homestay_id: homestay.id });
        this.props.history.push(path);
    }

    onClickManageCustomPrices = () => {
        const { homestay } = this.state;
        const path = Func.getPathWithParams(PATHS.CUSTOM_PRICE.LIST.path, { homestay_id: homestay.id });
        this.props.history.push(path);
    }

    onClickManageRates = () => {
        const { homestay } = this.state;
        const path = Func.getPathWithParams(PATHS.HOMESTAY_RATE.LIST.path, { homestay_id: homestay.id });
        this.props.history.push(path);
    }

    onClickManageBookablePackageRates = () => {
        const { homestay } = this.state;
        const path = Func.getPathWithParams(PATHS.BOOKABLE_PACKAGE_RATE.LIST.path, { homestay_id: homestay.id });
        this.props.history.push(path);
    }

    onClickRateCompare = () => {
        const { homestay } = this.state;
        const path = Func.getPathWithParams(PATHS.RATE_COMPATE.LIST.path, { homestay_id: homestay.id });
        this.props.history.push(path);
    }

    removeImages = (i, k) => {
        if (!i) return;
        const homestay = this.state.homestay;
        if (i === "https://null") {
            homestay.media = homestay.media.filter((i, index) => index !== k)
        } else {
            homestay.removeMedia(i)
        }
        this.setState({ homestay });
    };

    updateHomestayDetail() {
        const { homestay, action, tagGroups } = this.state;
        const actionFunction = action === DETAIL_ACTIONS.CREATE ? this.props.createHomestayDetail : this.props.updateHomestayDetail;
        actionFunction(homestay);
        // if(action === DETAIL_ACTIONS.UPDATE){
        //     this.props.updateTagGroupDetailSkuActive(tagGroups, homestay.id)
        // }
    }

}
